import { Alert, Card, Stack } from '@mui/material'
import { EmissionTier } from '../common'
import WaterRiskOverview from './waterRisk/WaterRiskOverview'

const PropertyWaterRisk: React.FC<any> = ({ propertyId, emissionTier }) => {
  const numericPropertyId =
    typeof propertyId === 'string' ? (isNaN(Number(propertyId)) ? null : Number(propertyId)) : propertyId

  if (!numericPropertyId) {
    return <Alert severity="info">Select a property to view water risk metrics.</Alert>
  }

  return (
    <Stack spacing={4}>
      <Card sx={{ p: 3 }}>
        <WaterRiskOverview propertyId={numericPropertyId} emissionTier={emissionTier} />
      </Card>
    </Stack>
  )
}

export default PropertyWaterRisk
